import Mention from './MarkdownMention';

import { renderMention as render } from './MentionRenderer';
import { SuggestionCandidate } from './typings';

type CreateSuggestionArguments = {
  char?: string;
  items: SuggestionCandidate[];
  // NOTE: praseKnownOnly parses only the given known items from the mention's items list.
  // If you type something like @hahaasd and it's not part of the configured Mention extension, it won't be parsed and icluded as a mention mark.
  parseKnownOnly?: boolean;
  // NOTE: When the user selects an item from the list and hits enter, this option will insert a space after the selected item.
  insertSpaceAfterCompletion?: boolean;
};

export function createMention({
  char = '@',
  items,
  parseKnownOnly = true,
  insertSpaceAfterCompletion = false,
}: CreateSuggestionArguments) {
  return Mention.configure({
    HTMLAttributes: {
      class: 'bg-primary-100 rounded text-primary-600 p-1 box-decoration-clone',
    },
    renderText({ options, node }) {
      return `${options.suggestion.char}${node.attrs.label ?? node.attrs.id}`;
    },
    char,
    items,
    parseKnownOnly,
    suggestion: {
      items: ({ query }) => {
        return items
          .filter(item => item.label.toLowerCase().startsWith(query.toLowerCase()))
          .slice(0, 5);
      },
      char,
      render,
      command: ({ editor, range, props }) => {
        // increase range.to by one when the next node is of type "text"
        // and starts with a space character
        const nodeAfter = editor.view.state.selection.$to.nodeAfter;
        const overrideSpace = nodeAfter?.text?.startsWith(' ');

        if (overrideSpace) {
          range.to += 1;
        }

        editor
          .chain()
          .focus()
          .insertContentAt(range, [
            {
              type: Mention.name,
              attrs: props,
            },
            ...(insertSpaceAfterCompletion ? [{ type: 'text', text: ' ' }] : []),
          ])
          .run();

        // get reference to `window` object from editor element, to support cross-frame JS usage
        editor.view.dom.ownerDocument.defaultView?.getSelection()?.collapseToEnd();
      },
    },
  });
}
